import AdvertiseIntroductionItem from "./AdvertiseIntroductionItem.vue";
export default {
  name: "AdvertiseIntroduction",
  components: {
    AdvertiseIntroductionItem
  },
  data() {
    return {
      list: [{
        key: "introduction1",
        icon: "info_1.png",
        title: "MillionInfluencers",
        des: "MillionInfluencersDes"
      }, {
        key: "introduction2",
        icon: "info_2.png",
        title: "InfluencerMarketingSimplified",
        des: "InfluencerMarketingSimplifiedDes"
      }, {
        key: "introduction3",
        icon: "info_3.png",
        title: "RevenueIncrease",
        des: "RevenueIncreaseDes"
      }]
    };
  }
};